import { __assign } from "tslib";
import * as React from 'react';
import { memo } from 'react';
var SvgAccount24 = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", "data-test-id": "icons-account-24", viewBox: "0 0 24 24", role: "img" }, props),
    React.createElement("title", null, 'Account 24 Icon'),
    React.createElement("g", { stroke: "currentColor", strokeWidth: 2 },
        React.createElement("rect", { width: 18, height: 18, x: 3, y: 3, rx: 9 }),
        React.createElement("path", { d: "M12 21a8.96 8.96 0 0 1-5.818-2.133C7.812 17.797 9.465 17 12 17c2.535 0 4.187.798 5.818 1.867A8.96 8.96 0 0 1 12 21z" }),
        React.createElement("circle", { cx: 12, cy: 11, r: 3 })))); };
var Memo = memo(SvgAccount24);
export default Memo;
//# sourceMappingURL=Account24.js.map